var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9577 19.6445L17.4363 4.3776H19.5772V3.85206H14.0109V2.45939C14.0109 1.69736 13.4316 1.09299 12.7011 1.09299H7.966C7.23557 1.09299 6.65628 1.69736 6.65628 2.45939V3.85206H1.08997V4.3776H3.23085L3.70941 19.6445C3.73459 20.354 4.2887 20.9058 4.96875 20.9058H15.6732C16.3784 20.9058 16.9325 20.354 16.9577 19.6445ZM7.16001 2.45939C7.16001 1.9864 7.51263 1.61852 7.966 1.61852H12.7011C13.1545 1.61852 13.5071 1.9864 13.5071 2.45939V3.85206H7.16001V2.45939ZM4.21314 19.6182L3.73459 4.3776H16.9325L16.454 19.6182C16.4288 20.0386 16.1014 20.3802 15.6984 20.3802H4.96875C4.56576 20.3802 4.23833 20.0386 4.21314 19.6182Z",
    fill: "#6479F8",
    stroke: "#6479F8",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6736 21H4.96874C4.23877 21 3.64643 20.4064 3.61944 19.6486L3.14359 4.4723H1V3.75907H6.56631V2.46024C6.56631 1.64144 7.18114 1 7.96598 1H12.7011C13.486 1 14.1008 1.64144 14.1008 2.46024V3.75907H19.6671V4.4723H17.5231L17.0504 19.5515H17.0508L17.0472 19.6486C17.0202 20.4064 16.4166 21 15.6732 21H15.6736ZM1.17991 4.28414H3.3181L3.79935 19.6416C3.82273 20.2976 4.33637 20.8118 4.96874 20.8118H15.6736C16.3267 20.8118 16.8376 20.3149 16.8673 19.6538V19.6416L17.349 4.28414H19.4872V3.9463H13.9209V2.45978C13.9209 1.74608 13.3852 1.18722 12.7011 1.18722H7.96598C7.28189 1.18722 6.74622 1.74608 6.74622 2.45978V3.9463H1.17991V4.28414ZM4.96874 20.4745C4.52347 20.4745 4.15196 20.101 4.12363 19.6242V19.6214L3.64193 4.28367H17.0256L16.5439 19.6214C16.5151 20.101 16.1441 20.474 15.6984 20.474H4.96874V20.4745ZM4.30308 19.6139C4.32647 19.9912 4.61837 20.2868 4.96874 20.2868H15.6984C16.0492 20.2868 16.3415 19.9907 16.364 19.6125L16.8394 4.47137H3.82723L4.30263 19.6134L4.30308 19.6139ZM13.5971 3.9463H7.07005V2.45978C7.07005 1.93565 7.46359 1.52507 7.96598 1.52507H12.7011C13.2035 1.52507 13.5971 1.93565 13.5971 2.45978V3.9463ZM7.24995 3.7586H13.4172V2.45978C13.4172 2.04075 13.1028 1.71276 12.7011 1.71276H7.96598C7.56434 1.71276 7.24995 2.04075 7.24995 2.45978V3.7586Z",
    fill: "#6479F8",
    stroke: "#6479F8",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0811 8.37173H10.5848V16.2285H10.0811V8.37173Z",
    fill: "#6479F8",
    stroke: "#6479F8",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6747 16.3223H9.99109V8.27786H10.6747V16.3223ZM10.171 16.1347H10.4948V8.46555H10.171V16.1347Z",
    fill: "#6479F8",
    stroke: "#6479F8",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05884 8.37173H7.56258V16.2285H7.05884V8.37173Z",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65252 16.3223H6.96887V8.27786H7.65252V16.3223ZM7.14878 16.1347H7.47261V8.46555H7.14878V16.1347Z",
    fill: "#6479F8",
    stroke: "#6479F8",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1046 8.37173H13.6084V16.2285H13.1046V8.37173Z",
    fill: "#6479F8",
    stroke: "#6479F8",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6983 16.3223H13.0146V8.27786H13.6983V16.3223ZM13.1946 16.1347H13.5184V8.46555H13.1946V16.1347Z",
    fill: "#6479F8",
    stroke: "#6479F8",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlue);
export default __webpack_public_path__ + "static/media/delete-blue.160789f092c40a64b6e2cc246d841895.svg";
export { ForwardRef as ReactComponent };